// What the details panel needs to build and read a list request (story 175, contract §4), kept apart from
// the panel so it stays plain functions.

// S127 / DL-1 (b) -- the "Required date" column keeps its historical `field: 'deliveryDate'` (saved tunes
// find it by that field, RN40), but it is SORTED by the contract §4 key `requiredDate` (the order's target
// day, absences last). The translation happens when the request is built; Sun sorts, the client never
// reorders a row (RN37/RN38).
const SORT_KEY_BY_FIELD = { deliveryDate: 'requiredDate' }
// Contract §4 -- the sort keys that ask Sun for the delivery classification (RN37/RN38).
const DELIVERY_SORT_KEYS = ['deliveryDeviationDays', 'expectedEndDate', 'requiredDate']

/** @returns {Boolean} The query sorts by a key that asks Sun for the delivery classification */
export const asksDeliverySort = (queryBuilder) => Array.isArray(queryBuilder?.sortKey) && queryBuilder.sortKey.some((key) => DELIVERY_SORT_KEYS.includes(key))

/** The pagination with the sort key of the "Required date" column translated to the one Sun knows. */
export const withDeliverySortKeys = (pagination) => {
  if (!Array.isArray(pagination?.sortKey) || !pagination.sortKey.some((key) => SORT_KEY_BY_FIELD[key])) {
    return pagination
  }
  return { ...pagination, sortKey: pagination.sortKey.map((key) => SORT_KEY_BY_FIELD[key] ?? key) }
}

/**
 * RN43 (S162): a recalculation can leave the current page beyond the end (fewer rows than before). Sun then
 * answers that page empty but still reports how many rows there are; the table asks once more for the last
 * page that has rows, and follows the page number of that answer (as it does for S121).
 * @param {Function} post `apiPost`-like, called with `(url, body)`
 */
export const lastPageWithDataIfOutOfRange = async (post, url, request, response) => {
  const requestedPage = request.queryBuilder?.page ?? 0
  const size = response?.size || request.queryBuilder?.size
  const isEmptyBeyondTheEnd = Array.isArray(response?.content) && response.content.length === 0 && response.totalElements > 0 && requestedPage > 0 && size > 0
  if (!isEmptyBeyondTheEnd) {
    return response
  }
  const lastPage = Math.ceil(response.totalElements / size) - 1
  if (lastPage >= requestedPage) {
    return response
  }
  return post(url, { ...request, queryBuilder: { ...request.queryBuilder, page: lastPage } })
}
